import { render, staticRenderFns } from "./TopluHacizTalepDuzenleForm.vue?vue&type=template&id=73a57af0&scoped=true"
import script from "./TopluHacizTalepDuzenleForm.vue?vue&type=script&lang=ts"
export * from "./TopluHacizTalepDuzenleForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a57af0",
  null
  
)

export default component.exports